module.exports = __webpack_public_path__ + "img/open-cage-count-icon.ef9ba2cc.png";